export default __webpack_public_path__ + "static/media/daCrazymidsm.7e731204.svg";